import { breakpointsTailwind, createSharedComposable, useBreakpoints } from "@vueuse/core";

function useCloudBreakpointsFn() {
  const breakpoints = useBreakpoints(breakpointsTailwind);

  const belowSm = breakpoints.smaller("sm");
  const atLeastSm = breakpoints.greaterOrEqual("sm");

  return {
    ...breakpoints,
    belowSm,
    atLeastSm,
  };
}

export const useCloudBreakpoints = createSharedComposable(useCloudBreakpointsFn);
